import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ClientMaster, SIDClientMaster } from '../models/client-master.model';

@Injectable({
  providedIn: 'root'
})
export class ClientMasterBehaviorService {
  private clientMaster: BehaviorSubject<ClientMaster>;
  // private sidclientMaster: BehaviorSubject<SIDClientMaster>;

  constructor() {
    this.clientMaster = new BehaviorSubject<ClientMaster>({
      Markets: [],
      SubMarkets: [],
      Clients: [],
      visibleClients: [],
      Months: [],
      ReportSource: [],
      MarginCost: false
    });
    // this.sidclientMaster = new BehaviorSubject<SIDClientMaster>({
    //   Markets: [],
    //   SubMarkets: [],
    //   OpportunityClients: [],
    //   RateClients: [],
    //   Roles: [],
    //   SoldVsStaffedClients: []
    // });
  }

  getClientMaster(): Observable<ClientMaster> {
    return this.clientMaster.asObservable();
  }
  setClientMaster(clientMaster: ClientMaster): void {
    this.clientMaster.next(clientMaster);
  }
  // getSIDClientMaster(): Observable<SIDClientMaster> {
  //   return this.sidclientMaster.asObservable();
  // }
  // setSIDClientMaster(sidclientMaster: SIDClientMaster): void {
  //   this.sidclientMaster.next(sidclientMaster);
  // }
}
